import {LookupList} from "./LookupList";
import {LookupEdit} from "./LookupEdit";
import {LookupCreate} from "./LookupCreate";

export default {
    list: LookupList,
    create: LookupCreate,
    edit: LookupEdit
};
